import { render } from "./text-highlight-right.vue?vue&type=template&id=19ee5319&scoped=true"
const script = {}

import "./text-highlight-right.vue?vue&type=style&index=0&id=19ee5319&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19ee5319"],['__file',"src/views/other/cssfx/components/text-highlight-right.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "19ee5319"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('19ee5319', __exports__)) {
    console.log('reload')
    api.reload('19ee5319', __exports__)
  }
  
  module.hot.accept("./text-highlight-right.vue?vue&type=template&id=19ee5319&scoped=true", () => {
    console.log('re-render')
    api.rerender('19ee5319', render)
  })

}


export default __exports__